<template>
  <div class="modal fade" id="podftUploadModal" tabindex="-1" aria-labelledby="podftUploadModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header">
          <h5 class="modal-title" id="clientModalLabel">Загрузка документ(ов) <b v-html="text"></b></h5>
          <button @click="clear" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="errorMessage" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-10 align-items-center">
            <div class="d-flex flex-column text-light pe-0 pe-sm-10">
              {{ errorMessage }}
            </div>
          </div>
          <h6 class="mb-2 text-gray-700">Передняя часть документа</h6>
          <div class="file-upload__panel">
            <template v-if="!docFrontImage">
              <input type="file" class="file-upload" v-on:change="onChangeFirst">
              <div class="file-upload__panel_content">
                <i class="ki-duotone ki-picture fs-3x">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="mt-2 text-gray-500">Выберите файл</div>
              </div>
            </template>
            <template v-else>
              <img v-if="docFrontImage" style="width: 100%; border-radius: 6px;" :src="docFrontImage" alt="">
              <div class="deleted-image" @click="deletedFirstDoc">
                <i class="ki-duotone ki-trash-square fs-4tx text-white">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                </i>
              </div>
            </template>
          </div>
          <br>
          <h6 class="mb-2 text-gray-700">Задняя часть документа</h6>
          <div class="file-upload__panel">
            <template v-if="!docBackImage">
              <input type="file" class="file-upload" v-on:change="onChangeSecond">
              <div class="file-upload__panel_content">
                <i class="ki-duotone ki-picture fs-3x">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="mt-2 text-gray-500">Выберите файл</div>
              </div>
            </template>
            <template v-else>
              <img v-if="docBackImage" style="width: 100%; border-radius: 6px;" :src="docBackImage" alt="">
              <div class="deleted-image" @click="deletedSecondDoc">
                <i class="ki-duotone ki-trash-square fs-4tx text-white">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                </i>
              </div>
            </template>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
              :disabled="loader"
              @click="clear"
              data-bs-dismiss="modal"
              type="button"
              class="btn btn-sm btn-secondary"
          >Отмена</button>
          <button
              :disabled="!(this.docFront || this.docBack)"
              @click="upload"
              type="button"
              class="btn btn-sm btn-primary"
          >Загрузить
          </button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios      from 'axios';
import LoaderFull from '@/components/Main/LoaderFull.vue';
import crypto     from '@/helpers/crypto';

export default {
  name: 'PodftUploadModal',
  components: {LoaderFull},
  data () {
    return {
      loader: false,
      docFront: null,
      docFrontImage: null,
      docBack:  null,
      docBackImage:  null,
      errorMessage: null
    }
  },
  props: {
    number: null,
    index: null,
    type: null,
    text: null,
    ulid: null
  },
  methods: {
    onChangeFirst(e) {
      this.docFront = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.docFront);
      reader.onload = e => {
        this.docFrontImage = e.target.result;
      }
    },
    onChangeSecond(e) {
      this.docBack = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.docBack);
      reader.onload = e => {
        this.docBackImage = e.target.result;
      }
    },
    deletedFirstDoc() {
      this.docFront = null;
      this.docFrontImage = null;
    },
    deletedSecondDoc() {
      this.docBack = null;
      this.docBackImage = null;
    },
    clear() {
      this.docFront = null;
      this.docFrontImage = null;
      this.docBack = null;
      this.docBackImage = null;
    },
    upload() {
      this.loader = true
      const config = {headers: {'content-type': 'multipart/form-data'}}
      let data = new FormData();
      data.append('id', this.number);
      data.append('front', this.docFront);
      data.append('back', this.docBack);
      data.append('ulid', this.ulid);
      axios.post('/api/podft/upload', data, config)
          .then(res => {
            if (res.data.id) {
              const data = {
                index: this.index,
                type: this.type,
                data: res.data
              }
              this.$emit('updatePodftData', data)
              this.clear()
              this.modalHidden()
            }
          })
          .catch(err => {
            this.errorMessage = err.response.data.message ?? err.message
          })
          .finally(() => {this.loader = false})
    },
    modalHidden() {
      const myModalEl = document.getElementById('podftUploadModal');
      const modal = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
  },
  watch: {
    docFront: {
      deep: true,
      handler() {
        this.errorMessage = null
      }
    },
    docBack: {
      deep: true,
      handler() {
        this.errorMessage = null
      }
    }
  }
}
</script>

<style scoped>
</style>